import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import moment from "moment";
import { useTunnelSteps, useRemoveCoupon } from "@hooks/use-tunnel-steps";
import CouponMessage from "@components/core/CouponMessage/CouponMessage";
import redeemTypes from "@utils/constants/redeemTypes";

const initRemainingTime = {
  minutes: 0,
  seconds: 0,
};

function PromotionalBanner() {
  const t = useTranslations("common");

  const { coupon, featuredPlan, couponToApply } = useTunnelSteps();
  const removeCoupon = useRemoveCoupon();

  const [remainingTime, setRemainingTime] = useState(initRemainingTime);

  function removeCountdown() {
    sessionStorage.removeItem("chrono_banner");
    setRemainingTime(initRemainingTime);
  }

  function startTimeOut(timeInterval) {
    setTimeout(() => {
      const timerInStorage = sessionStorage.getItem("chrono_banner");
      const now = new Date();
      const diff = moment(timerInStorage).diff(now);

      if (diff <= 0) {
        sessionStorage.removeItem("redeemCodeToken");
        removeCoupon();
        removeCountdown();
      } else {
        setRemainingTime({
          minutes: moment.duration(diff).minutes(),
          seconds: moment.duration(diff).seconds(),
        });
        startTimeOut(1000);
      }
    }, timeInterval);
  }

  function findOrCreateCountdown() {
    const timerInStorage = sessionStorage.getItem("chrono_banner");

    if (!timerInStorage) {
      const newTimer = moment(new Date()).add(15, "minutes").toDate();
      sessionStorage.setItem("chrono_banner", newTimer);
    }

    startTimeOut(0);
  }

  useEffect(() => {
    if ([redeemTypes.couponAmountOff, redeemTypes.couponPercentOff].includes(coupon?.type)) {
      findOrCreateCountdown();
    } else {
      removeCountdown();
    }
  }, [coupon]);

  if (!coupon || (coupon.type !== redeemTypes.referring && !featuredPlan)) return null;

  const couponPrefix = () => {
    if (!couponToApply.promo_text_prefix) return null;

    return t("coupon_message.prefix", { prefix: couponToApply.promo_text_prefix });
  };

  const returnTimerMessage = () => (
    <div
      className="border border-lighter bg-white ms-2 d-flex justify-content-center align-items-center text-primary font-size-sm"
      style={{
        borderRadius: "4px",
        minWidth: "58px",
        maxWidth: "58px",
        height: "24px",
      }}
    >
      <span
        className="text-end"
        style={{ minWidth: "18px", maxWidth: "18px" }}
      >
        {remainingTime.minutes < 10 ? `0${remainingTime.minutes}` : remainingTime.minutes}
      </span>
      <span>&nbsp;:&nbsp;</span>
      <span
        className="text-start"
        style={{ minWidth: "18px", maxWidth: "18px" }}
      >
        {remainingTime.seconds < 10 ? `0${remainingTime.seconds}` : remainingTime.seconds}
      </span>
    </div>
  );

  return (
    <div className="bg-tertiary w-100 p-2 d-flex justify-content-center align-items-center">
      <p className="text-center mb-0 text-white text-uppercase font-size-sm">
        {couponPrefix()}
        <CouponMessage />
      </p>
      {(remainingTime.minutes > 0 || remainingTime.seconds > 0) && returnTimerMessage()}
    </div>
  );
}

export default PromotionalBanner;
